
export default {
  reportDetails: null,
  confirmorList: [],
};
